import { Outlet } from 'react-router';

/**
 * Layout for public pages (landing, login, register, etc.)
 * — no sidebar, no auth required.
 */
export function PublicLayout() {
  return (
    <div className="min-h-dvh bg-background">
      <Outlet />
    </div>
  );
}
